export default {

    groupChecks: [],
    currencyVerifiersList: [],
    activeGroupCheck:{ },

    manageGroupCheckDialog: false,


}